<!-- eslint-disable -->
<template lang="pug">
    .modal.conversation.is-active.hidmeinfirefox(ref="modal")
        .modal-background
        .modal-card
            section.modal-card-body.map-conversation(:style="modalCardBodyStyle")
                template(v-if="!isLoading && isSoundsLoaded")
                    .columns(
                         :class="user.type === 'student' && isCurrentCity && 'with-padding'"
                    )
                        .column.left-interlocutor
                            transition(name="fade")
                                .map-conversation__submarine-container(v-if="continentTransition")
                                    submarine.map-conversation__submarine.animated.tada.infinite(:glowing="true")
                                img.map-conversation-image(:src="leftInterlocutor" v-else)

                        .column.center-column
                            .conversation-block(ref="chat" :class="isDialogRunning && 'is-active'")
                                transition-group(name="speech" tag="div")
                                    .speech-bubble(
                                        v-if="output.length !== 0" v-for="(message, index) in output"
                                        :class="[message.source === 'turtle' ? 'right' : 'left',continentTransition && 'speech-bubble__continent-transition']"
                                        :key="placeName + index"
                                    )
                                        | {{ $i18n.t(`mapConversations.${placeName}.${index}`) }}
                        .column.right-interlocutor(:class="{'is-3': continentTransition}")
                            img.map-conversation-image(:src="rightInterlocutor")
                    .conversation-buttons(v-if="areButtonsAvailable")
                        button.button.is-disabled.progress-button(
                            v-if="user.miles - user.mapLocation.requiredMiles < 0"
                        )
                            span.progress-bar-header
                                |   {{ $i18n.t('map.map_conversation_left') }}
                                |   {{ user.mapLocation.requiredMiles - user.miles }}
                                |   {{ $i18n.t('map.map_conversation_milesToGo') }}
                                |   {{ cases.genitive[user.mapLocation.nextCity] }}!
                            progress.progress.progress_info(:value="user.miles" :max="user.mapLocation.requiredMiles")
                            span.progress-text
                                |   {{ user.miles }} из {{ user.mapLocation.requiredMiles }}
                        button.button.next-city(
                            :class="isButtonLoading && 'is-loading'"
                            v-else-if="user.miles - user.mapLocation.requiredMiles >= 0"
                            @click="updateCity"
                        )
                            |   {{ $i18n.t('map.map_conversation_go') }}
                            |   {{ locationsWithPretext[user.mapLocation.nextCity] }}
                    .map-conversation-buttons
                        a.button.delete(
                            @click="$emit('close')"
                            href="javascript://"
                            :class="isButtonDisabled && 'is-disabled'"
                            :title="$i18n.t('map.map_conversation_close')"
                        )
                        a.refresh-dialog-icon(
                            href="javascript://"
                            @click="refreshDialog"
                            :class="{'is-disabled': isButtonDisabled || isButtonRefreshing}"
                            :title="$i18n.t('map.map_conversation_playConversation')"
                        )
                            i.fa.fa-refresh
                cs-loader(v-else)
</template>

<style lang="scss" scoped>
    @import '@/assets/sass/map/conversation-modal.scss';
    .map-conversation__submarine-container {
        width: 100%;
    }
    .map-conversation__submarine {
        width: 100%;
        height: 100%;
        margin: auto;
    }
    .speech-bubble__continent-transition {
        @media screen and (min-width: 1024px) {
            width: 100%;
            max-width: none;
        }
    }

    .speech-bubble {
        transition: all 0.5s;
        opacity: 1;
        transform: translateY(0);
    }

    .conversation-buttons {
        transition: all 1s;
        opacity: 1;
    }

    .speech-enter-active {
        opacity: 0;
        transform: translateY(100px);
    }

    .speech-leave-active {
        opacity: 0;

        position: absolute;
        bottom: 0;
    }

    .right.speech-leave-active {
        right: 0;
    }

    .left.speech-leave-active {
        left: 0;
    }

    .fade-enter-active {
        opacity: 0;
    }

    @-webkit-keyframes tada {
        from {
            -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
        }

        10%,
        20% {
            -webkit-transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -3deg);
            transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -3deg);
        }

        30%,
        50%,
        70%,
        90% {
            -webkit-transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, 3deg);
            transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, 3deg);
        }

        40%,
        60%,
        80% {
            -webkit-transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, -3deg);
            transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, -3deg);
        }

        to {
            -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
        }
    }

    @keyframes tada {
        from {
            -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
        }

        10%,
        20% {
            -webkit-transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -3deg);
            transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -3deg);
        }

        30%,
        50%,
        70%,
        90% {
            -webkit-transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, 3deg);
            transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, 3deg);
        }

        40%,
        60%,
        80% {
            -webkit-transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, -3deg);
            transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, -3deg);
        }

        to {
            -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
        }
    }

    .tada {
        -webkit-animation-name: tada;
        animation-name: tada;
    }

    .animated {
        -webkit-animation-duration: 1.5s;
        animation-duration: 1.5s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }

    .animated.infinite {
        -webkit-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
    }
</style>

<style lang="scss" scoped>
    .progress_info {
        width: 23rem;
    }

    .progress-text {
        top: auto;
    }
</style>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import UserApi from "../../../../api/user/user";
    import MapConversationApi from "../../../../api/map/map-conversation";
    import continents from '../../../../config/continents'
    import _ from 'lodash'
    import Submarine from '../../map/map-assets/submarine/Index.vue'
    import continentTransitionBackground from '../../../../assets/images/trainer/simulator.jpg'
    import continentsWithTransition from '../../map/config/continentsWithTransition'
    import CITIES from '../../../../config/cities.json'

    const DELAY = 500;

    export default {
        props: {
            cityName: String,
            isMobile: Boolean,
            isFirstTime: Boolean
        },
        mounted () {
            this.isFirefox = !! navigator.userAgent.match(/firefox/ig);
            this.$refs.modal.addEventListener(this.isFirefox ? 'DOMMouseScroll' : 'mousewheel', this.scrollHandle);
            this.isButtonDisabled = this.isFirstTime;
            document.addEventListener('keydown', this.closeModalHandler);
            let mc = new Hammer.Manager(document.querySelector('.map-conversation'));
            let Swipe = new Hammer.Swipe({
                event: 'swipe',
                pointers: 1,
                threshold: 5,
                direction: Hammer.DIRECTION_VERTICAL,
                velocity: 0.2
            });
            this.placeName = this.cityName;
            mc.add(Swipe);
            mc.on('swipe', (e) => _.throttle(this.scrollHandle, 2000)({...e, deltaY: -e.deltaY}));
            if (this.$root.continentTransition) {
              this.updateCity();
            } else {
              this.cityName ? this.fetchData() : this.$emit('close');
            }
            document.body.style = 'overflow-y = hidden;'
        },
        watch: {
            isSoundsLoaded (val) {
                if (val) {
                    this.$nextTick(() => {
                        this.showDialog();
                    })
                }
            },
            output: {
                handler () {
                    this.setBackgroundImage();
                },
                deep: true
            }
        },
        beforeDestroy () {
            this.$refs.modal.removeEventListener(this.isFirefox ? 'DOMMouseScroll' : 'mousewheel', this.scrollHandle);
            document.removeEventListener('keydown', this.closeModalHandler);
            this.$createjs.Sound.removeAllSounds();
            this.$createjs.Sound.removeAllEventListeners();
            this.insertedRules.forEach(rule => {
                document.styleSheets[0].deleteRule(rule);
            })
        },
        methods: {
            setBackgroundImage (isPreloading = false) {
                if (this.continentTransition) {
                    this.currentImage = continentTransitionBackground;
                    return;
                }
                let foundElement;
                if (isPreloading) {
                    foundElement = this.isFirstTime ?
                        this.conversation[0] : _.findLast(this.conversation, elem => elem.backgroundUrl);
                } else {
                    foundElement = _.findLast(this.output, elem => elem.backgroundUrl);
                }
                if (foundElement && foundElement.backgroundUrl !== this.currentImage) {
                    this.currentImage = this.$apiEndpoint + foundElement.backgroundUrl;
                }
            },
            registerSounds () {
                return new Promise((resolve) => {
                    this.$createjs.Sound.removeAllSounds();
                    this.$createjs.Sound.removeAllEventListeners();
                    this.$createjs.Sound.on("fileload", () => {
                        this.isSoundsLoaded = true;
                        resolve();
                    });
                    this.$createjs.Sound.alternateExtensions = ["mp3"];
                    this.sounds.forEach(sound => {
                        sound.src = this.$apiEndpoint + sound.src;
                    });
                    this.$createjs.Sound.registerSounds(this.sounds);
                });
            },
            playSounds (index = 1) {
                this.soundInstance = this.$createjs.Sound.play(index);
                if (this.replaceVoiceActingOnMusic) {
                    this.soundInstance.volume = 0;
                }
                this.soundInstance.on("complete", () => {
                    this.conversation.length > index && this.output.push(this.conversation[index]);
                    setTimeout(() => {
                        if (this.conversation.length > index) {
                            this.playSounds(index + 1)
                        } else {
                            if (this.continentTransition) {
                                this.updateCity();
                                return;
                            }

                            if (this.$refs.chat) {
                                this.$refs.chat.style['min-height'] =
                                  `calc(100% - ${window.innerWidth < 1024 ? window.innerWidth < 768 ? 0 : 15 : 20}rem + 0.5rem)`;
                            }

                            this.isButtonDisabled = false;
                            this.isDialogRunning = false;

                            document.addEventListener('keydown', this.closeModalHandler);
                        }
                    }, DELAY)
                })
            },
            scrollHandle (e) {
                if (!this.isDialogRunning && this.isSoundsLoaded) {
                    if (e[this.isFirefox ? 'detail' : 'deltaY'] < 0) {
                        this.output.length > 0 && this.output.pop();
                    } else {
                        this.conversation[this.output.length] && this.output.push(this.conversation[this.output.length])
                    }
                }
            },
            closeModalHandler (event) {
                event.preventDefault();
                if (event.keyCode === 27) {
                    this.$emit('close');
                }
            },
            refreshDialog () {
                this.soundInstance && this.soundInstance.stop();
                this.isButtonRefreshing = true;
                this.output = [];
                this.$nextTick(() => {
                    this.output.push(this.conversation[0]);
                    this.$refs.chat.style['min-height'] = '0px';
                    this.isDialogRunning = true;
                    setTimeout(() => {
                        this.playSounds();
                        this.isButtonRefreshing = false;
                    }, DELAY)
                })
            },
            showDialog () {
                if (this.isFirstTime) {
                    document.removeEventListener('keydown', this.closeModalHandler);
                    this.$refs.chat.style['min-height'] = '0px';

                    this.isButtonDisabled = true;
                    this.isDialogRunning = true;

                    this.output.push(this.conversation[0]);
                    setTimeout(() => {
                        this.playSounds();
                    }, DELAY)
                } else {
                    this.$refs.chat.style['min-height'] =
                        `calc(100% - ${window.innerWidth < 1024 ? window.innerWidth < 768 ? 0 : 15 : 20}rem + 0.5rem)`;
                    this.output.push(...this.conversation);
                }
            },
            fetchData () {
                this.isLoading = true;
                return MapConversationApi.show(this.cityName)
                    .then(data => {
                        if (!data) {
                            return Promise.reject();
                        }
                        this.leftInterlocutor = this.$apiEndpoint + data.leftInterlocutor;
                        this.rightInterlocutor = this.$apiEndpoint + data.rightInterlocutor;
                        this.conversation = data.conversation;
                        this.sounds = data.sounds;
                        return this.preloadFirstImage();
                    })
                    .then(() => {
                        this.setBackgroundImage(true);
                        if (this.isMobile) {
                            let sheet = document.styleSheets[0];
                            this.insertedRules.push(sheet.insertRule(`.speech-bubble.left:before { background-image: url("${this.leftInterlocutor}"); }`));
                            this.insertedRules.push(sheet.insertRule(`.speech-bubble.right:before { background-image: url("${this.rightInterlocutor}"); }`));
                        }
                        this.isLoading = false;
                        return this.registerSounds();
                    })
                    .then(() => {
                        return this.imagesPreload();
                    })
                    .catch(err => {
                        if (err) {
                            this.$toasted.error(err);
                        } else {
                          this.$toasted.error(this.$root.$t('errors.getting_messages'));
                        }
                        this.isLoading = false;
                        this.$emit('close');
                    })
            },
            preloadFirstImage () {
                return new Promise((resolve, reject) => {
                    let image = new Image();
                    image.onload = () => {
                        resolve();
                    };
                    image.onerror = () => {
                        reject(this.$root.$t('errors.getting_images'));
                    };
                    if (this.continentTransition) {
                        image.src = continentTransitionBackground;
                    } else {
                        let imagesSrc = this.imagesSrc;
                        image.src = this.$apiEndpoint + (this.isFirstTime ? imagesSrc[0] : imagesSrc[imagesSrc.length - 1]);
                    }
                });
            },
            imagesPreload () {
                return new Promise((resolve, reject) => {
                    let currentLoadedIndex = 0;
                    this.imagesSrc.forEach((src, index, array) => {
                    let image = new Image();
                    image.onload = () => {
                        if (++currentLoadedIndex >= array.length) {
                            resolve();
                        }
                    };
                    image.onerror = () => {
                        reject(this.$root.$t('errors.getting_images'));
                    };
                    image.src = this.$apiEndpoint + src;
                });
              });
            },
            newContinentTransition () {
                this.isButtonDisabled = true;
                this.continentTransition = true;
                this.output = [];
                this.isSoundsLoaded = false;
                this.$root.continentTransition = false;
                this.$emit('isFirstTime');
                MapConversationApi.show(continents[this.user.mapLocation.nextCity])
                    .then(data => {
                        this.placeName = continents[this.user.mapLocation.nextCity];
                        this.conversation = data.conversation;
                        this.rightInterlocutor = this.$apiEndpoint + data.rightInterlocutor;
                        this.sounds = data.sounds;
                        return this.preloadFirstImage();
                    })
                    .then(() => {
                        return this.registerSounds();
                    })
                    .catch(err => {
                        this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                        this.$emit('close');
                    });
            },
            updateCity () {
                if (this.isButtonLoading) {
                    return;
                }
                let nextContinent = continents[this.user.mapLocation.nextCity];
                if (continents[this.cityName] !== nextContinent
                    && !this.continentTransition && continentsWithTransition.includes(nextContinent)) {
                    this.newContinentTransition();
                    return;
                }
                this.isButtonLoading = true;
                if (this.user.mapLocation.nextCity) {
                    UserApi.updateCity(this.user.id)
                        .then(() => {
                            let newContinent = continents[this.user.mapLocation.nextCity];
                            if (newContinent !== continents[this.user.mapLocation.name]) {
                                this.$emit('changeContinent', newContinent);
                            }
                            this.$store.dispatch('setUserByToken');
                            this.isButtonLoading = false;
                            this.$emit('close');
                        })
                        .catch(error => {
                            this.isButtonLoading = false;
                            this.$toasted.error(this.$root.$t(`errors.${error.data.message}`));
                        })
                }
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            modalCardBodyStyle () {
                if (this.currentImage) {
                    return { 'background-image': 'url(' + this.currentImage + ')' }
                }
                return { background: 'white' };
            },
            isCurrentCity () {
                return this.cityName === this.user.mapLocation.name
            },
            areButtonsAvailable () {
                return this.isCurrentCity
                    && this.user.type === 'student'
                    && !this.isButtonDisabled
                    && this.$lastMapAvailableLocation !== this.cityName
                    && CITIES[CITIES.length - 1] !== this.cityName;
            },
            imagesSrc () {
                return this.conversation.filter(message => message.backgroundUrl).map(message => message.backgroundUrl);
            },
            replaceVoiceActingOnMusic () {
                return this.user.locale === 'bg' || this.user.locale === 'uk';
            }
        },
        data () {
            return {
                isDialogRunning: false,
                images: null,
                cases: this.$i18n.t('mapModal.cases'),
                isLoading: false,
                isButtonLoading: false,
                isButtonDisabled: false,
                isSoundsLoaded: false,
                isButtonRefreshing: false,
                locationsWithPretext: this.$i18n.t('mapModal.locationsWithPretext'),
                output: [],
                conversation: null,
                sounds: null,
                soundInstance: null,
                currentImage: null,
                isFirefox: false,
                continentTransition: false,
                leftInterlocutor: null,
                rightInterlocutor: null,
                placeName: '',
                insertedRules: [],
            }
        },
        components: {
            Submarine
        }
    }

</script>
